// Copyright (c) 2016 Deere & Company

import './non-editable-parts-panel.scss';
import React, {PropTypes} from 'react';
import ClaimPart from '@deere/cps-it.warranty-model-factory/lib/claim-item-part';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledString from '../../../../shared/components/labeled-string';

const NonEditablePartsPanel = props => {

    const panelClass = props.claimType === 'Special Allowance' ? 'non-editable-parts-panel special-allowance' : 'non-editable-parts-panel';

    return (
        <section className={panelClass}>
            <h3>{`${props.part.partNumber} - ${props.part.partDescription} ${props.part.partSerialNumber} (${props.part.quantity} ${props.part.unit.value})`}</h3>
            <div className='parts-panel-row'>
                <LabeledString
                    className='lost-two-column'
                    data={props.part.partReturnStatus.value}
                    label='RETURN_STATUS'
                />
                <LabeledCurrency
                    className='value'
                    data={props.part.partValue}
                    label='VALUE'
                />
                {props.claimType === 'Special Allowance' &&
                <LabeledCurrency
                    className='net'
                    data={props.part.dnsNetPrice}
                    label='NET'
                />
            }
                <LabeledCurrency
                    className='core'
                    data={props.part.coreValues}
                    label='CORE'
                />
            </div>
            <div className='parts-panel-row'>
                <LabeledCurrency
                    className='on-shelf'
                    data={props.part.onShelfCost}
                    label='ON_SHELF'
                />
                <LabeledCurrency
                    className='additive'
                    data={props.part.partAdditive}
                    label='ADDITIVE'
                />
                <LabeledCurrency
                    className='tax'
                    data={props.part.taxAmount}
                    label='TAX'
                />
                {props.claimType === 'Special Allowance' &&
                <LabeledCurrency
                    className='list'
                    data={props.part.dnsListPrice}
                    label='LIST'
                />
            }
                <LabeledCurrency
                    className='reimbursed'
                    data={props.part.reimbursementAmount}
                    label='REIMBURSED'
                />
            </div>
            {props.showPartInvoiceNumber &&
            <div className='parts-panel-row'>
                <LabeledString
                    className='lost-two-column'
                    data={props.part.invoiceNumber}
                    label='INVOICE_NUMBER'
                />
            </div>
        }
        </section>);

};

NonEditablePartsPanel.displayName = 'NonEditablePartsPanel';
NonEditablePartsPanel.propTypes = {
    claimType: PropTypes.string,
    part: PropTypes.instanceOf(ClaimPart).isRequired,
    showPartInvoiceNumber: PropTypes.bool.isRequired
};

export default NonEditablePartsPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/parts-panel/non-editable-parts-panel.js